import type { Location, NavigateFunction } from 'react-router-dom'

enum Channel {
  Change = 'change'
}
type Events = `${Channel}`
type Listener = (event: CustomEvent<{ location: Location }>) => void

class RouterService {
  private location!: Location
  // private navigate!: NavigateFunction
  private channel = new EventTarget()

  public setLocation(location: Location) {
    this.location = location
    this.channel.dispatchEvent(new CustomEvent(Channel.Change, { detail: { location } }))
  }

  public isCurrentLocationIn(paths: string[]) {
    return paths.includes(this.location.pathname)
  }

  public setNavigate(_: NavigateFunction) {
    // this.navigate = navigate
  }

  public on(event: Events, listener: Listener) {
    this.channel.addEventListener(event, listener as EventListenerOrEventListenerObject)
  }
}

export default RouterService
